import { formatCurrency } from '../../../lib/util/DataHelpers';

// Mirrors the price shown in the chart header (MainPriceInfo) so the hover label and header agree
export const formatTooltipPrice = (price: number): string => formatCurrency(price);
